import Permissions from '@/enums/Permissions';
import { useSession } from 'next-auth/react';
import { BUContext } from '@/utils/contexts/BusinessUnitContext';
import { useContext } from 'react';
import { getPermissions } from '../helpers/roles';

const usePermissions = (requiredPermission: Permissions) => {
	const selectedBusinessUnit = useContext(BUContext);
	const { data: session } = useSession();
	const companyPermissions = getPermissions(session?.company, session?.roles);

	if (requiredPermission === Permissions.UPDATE_BUSINESS_UNIT_DETAILS && companyPermissions) {
		return companyPermissions.includes(Permissions.UPDATE_BUSINESS_UNIT_DETAILS);
	}
	
	const buPermissions = getPermissions(session?.businessUnits.find((bu) => bu.value === selectedBusinessUnit), session?.roles) ?? [];

	return buPermissions?.includes(requiredPermission);
};

export { usePermissions };
